import React, { Component } from "react";
import Contentify from "../../content/Contentify";

export class Tooltip extends Component {
  render() {
    return (
      <div
        id={this.props.id}
        className={
          this.props.customStyle
            ? "input-tooltip  " + this.props.customStyle
            : "input-tooltip"
        }
      >
        {this.props.text}
      </div>
    );
  }
}

export default Contentify(Tooltip);
